<template>
    <div style="display: flex">
        <a-form :form="form" style="margin:30px 10px 10px 10px;flex: 1;">
            <a-form-item
                    label="所属分类"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <a-tree-select
                        v-decorator="[
                  'cate_ids',
                  {rules: [{ required: true, message: '请输入选择分类' }]}
                ]"
                        style=" width: 90% ; margin-right: 10px; "
                        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                        :treeData="cateOptions"
                        multiple
                        allowClear
                        treeNodeFilterProp="title"
                        placeholder='请选择分类'
                        treeDefaultExpandAll
                        v-model="formData.cate_ids"
                >
                </a-tree-select>
                <a-popover content="请选择分类,支持多选">
                    <a-icon type="question-circle"/>
                </a-popover>
            </a-form-item>


            <!--       <a-form-item-->
            <!--              label="商品类型"-->
            <!--              :labelCol="labelCol"-->
            <!--              :wrapperCol="wrapperCol"-->
            <!--      >-->
            <!--        <a-tree-select-->
            <!--                -->
            <!--                style=" width: 90% ; margin-right: 10px; "-->
            <!--                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"-->
            <!--                :treeData="extraTypes"-->
            <!--                multiple-->
            <!--                allowClear-->
            <!--                treeNodeFilterProp="name"-->
            <!--                placeholder='请选择类型'-->
            <!--                treeDefaultExpandAll-->
            <!--                v-model="formData.extra_types"-->
            <!--        >-->
            <!--        </a-tree-select>-->
            <!--        <a-popover content="请选择类型,支持多选">-->
            <!--          <a-icon type="question-circle" />-->
            <!--        </a-popover>-->
            <!--      </a-form-item> -->

            <!-- <a-form-item label="商品类型" :labelCol="labelCol" :wrapperCol="wrapperCol" extra="请选择商品类型">
              <a-select
                      showSearch
                      allowClear
                      v-model="formData.extra_types"
                      mode="multiple"
                      optionFilterProp="name"
                      placeholder="请选择类型"
              >
                <a-select-option :key="option.id" v-for="option in extraTypes" :name="option.name" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
              </a-form-item> -->
            <a-form-item
                    label="标题"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <a-input
                        style=" width: 90% ; margin-right: 10px; "
                        v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入商品标题' }]}
        ]"
                        placeholder="请输入商品标题（中文）"/>
                <a-popover content="请选择分类,支持多选">
                    <a-icon type="question-circle"/>
                </a-popover>
            </a-form-item>
            <a-form-item
                    label="英文标题"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <a-input
                        style=" width: 90% ; margin-right: 10px; "
                        v-decorator="['title_en']"
                        placeholder="English title"/>
            </a-form-item>
            <a-form-item label="商品描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea
                        v-decorator="[
          'desc',
          {rules: [{ required: true, message: '请输入商品描述' }]} ]"
                        placeholder="商品描述或简介（中文）"
                        :autosize="{ minRows: 2, maxRows: 6 }"
                />
            </a-form-item>
            <a-form-item label="英文描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea
                        v-decorator="['desc_en']"
                        placeholder="English description"
                        :autosize="{ minRows: 2, maxRows: 6 }"
                />
            </a-form-item>


            <a-form-item
                    v-if="false"
                    label="所属供应商"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra=""
            >
                <a-select
                        showSearch
                        allowClear
                        v-model="formData.base_id"
                        optionFilterProp="name"
                        placeholder="请选择供应商"
                >
                    <a-select-option :key="option.id" v-for="option in baseOptions" :name="option.name"
                                     :value="option.id">{{option.name}}
                    </a-select-option>
                </a-select>
            </a-form-item>


            <!--<a-form-item
                  label="列表小图"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="显示在列表页,推荐尺寸750x750,推荐格式jpg"
          >
            <pic-uploader
                    :file-list="formData.pic"
            />
          </a-form-item>-->

            <a-form-item
                    label="内页大图"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="显示详情页,推荐宽度750x525,推荐格式jpg"
            >
                <pic-uploader
                        :file-list="formData.pics"
                />
            </a-form-item>
            <a-form-item
                    label="首图视频"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <video-uploader :file-list="formData.videos" numberLimit="1"/>
            </a-form-item>
            <a-form-item
                    label="参数信息"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <div v-for="(item,k) in formData.extra_data" :key="k">
                    <a-input style=" width: 45%; margin-right: 10px" v-model="item.name" placeholder="参数名称"/>
                    <a-input style=" width: 45%; margin-right: 10px" v-model="item.value" placeholder="参数值"/>
                    <a-icon
                            class="dynamic-delete-button"
                            type="minus-circle-o"
                            @click="() => removeExtraField(k)"
                    />
                </div>
                <div>
                    <a-button
                            type="dashed"
                            style="width: 100%"
                            @click="addExtraField"
                    >
                        <a-icon type="plus"/>
                        增加参数
                    </a-button>
                </div>

            </a-form-item>

            <a-form-item
                    v-if="false"
                    label="下单选项"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <div v-for="(item,k) in formData.order_data" :key="k">
                    <div class="order_expr">
                        <a-input style=" width: 45%; margin-right: 10px" v-model="item.name" placeholder="参数名称"/>
                    <a-textarea
                        style=" width: 45%; margin-right: 10px"
                        v-model="item.value" placeholder="选项每行一个(属性=原价,内供价)"
                        :autosize="{ minRows: 2, maxRows: 6 }"
                />
                <a-icon
                            class="dynamic-delete-button"
                            type="minus-circle-o"
                            @click="() => removeOrderField(k)"
                    />
                    </div>
                    <!-- <a-input style=" width: 45%; margin-right: 10px" v-model="item.value" placeholder="参数值(多个选项以';'隔开)"/> -->
                    
                </div>
                <div>
                    <a-button
                            type="dashed"
                            style="width: 100%"
                            @click="addOrderField"
                    >
                        <a-icon type="plus"/>
                        增加参数
                    </a-button>
                </div>

            </a-form-item>

            <a-form-item
                    label="原价"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="显示在页面中的划线价"
            >

                <!--<a-input v-decorator="[-->
                <!--'orig_price',-->
                <!--{rules: [{ required: true, message: '请输入原价' }]}-->
                <!--]"-->
                <!--placeholder="请输入原价"/>-->
                <PriceInput :formData="formData"
                            field="orig_price"
                            placeholder="请输入原价"/>
            </a-form-item>


            <a-form-item
                    v-if="false"
                    label="虚拟销量"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    :extra="'页面显示销量('+ (parseInt(formData.sold_show_count)+parseInt(formData.sold_count)) +') = 虚拟销量('+parseInt(formData.sold_show_count)+') + 实际销量('+parseInt(formData.sold_count)+')'"
            >

                <a-input type="number"
                         v-model="formData.sold_show_count"
                         placeholder="请输入虚拟销量"/>
            </a-form-item>

            <a-form-item
                    v-if="false"
                    label="虚拟点击数"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    :extra="'页面显示点击数('+ (parseInt(formData.views_show_count)+parseInt(formData.views_count)) +') = 虚拟点击数('+parseInt(formData.views_show_count)+') + 实际点击数('+parseInt(formData.views_count)+')'"
            >
                <a-input
                        type="number"
                        v-model="formData.views_show_count"
                        placeholder="请输入虚拟点击数"/>
            </a-form-item>
            <a-form-item
                    label="限购数量"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="每个用户限制购买的数量,为0则表示不限制"
            >

                <a-input type="number"
                         v-model="formData.user_buy_limit"
                         placeholder="请设置限购数量"/>
            </a-form-item>
             <a-form-item
                    v-if="false"
                    label="积分限制"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="每件商品最多限用多少积分"
            >

                <a-input type="number"
                         v-model="formData.credit_limit"
                         placeholder="请设置限购数量"/>
            </a-form-item>

            <a-form-item
                    label="运费模板"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="请在运费模板管理中配置相关规则"
            >
                <a-select
                        showSearch
                        allowClear
                        v-model="formData.express_tpl_id"
                        optionFilterProp="title"
                        placeholder="选择运费模板"
                >
                    <a-select-option :key="option.id" v-for="option in expressTplOptions" :title="option.title"
                                     :value="option.id">{{option.title}}
                    </a-select-option>
                </a-select>

            </a-form-item>
            <a-form-item
                    label="固定运费"
                    v-if="!formData.express_tpl_id"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    :extra="'固定运费 = '+formData.express_price+'元/件'"
            >
                <PriceInput :formData="formData"
                            field="express_price"
                            placeholder="请输入固定运费"/>
            </a-form-item>

            <a-form-item
                    label="排序"
                    :labelCol="labelCol"
                    v-if="formData.id"
                    :wrapperCol="wrapperCol"
                    extra="商品在列表页的排序,数字越大越靠前"
            >
                <a-input type="number"
                         v-model="formData.rank"
                         placeholder="请输入排序值"/>
            </a-form-item>
            <a-form-item
                    v-if="false"
                    label="是否开启会员限购"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="开启时，只有会员才可以购买该商品"
            >
                <r-switch :formData="formData" field="member_buy_status" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启"
                          unCheckedChildren="关闭"/>

            </a-form-item>
            <!-- <a-form-item
                    label="下单时候创建采购单"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    extra="开启时，用户下单就自动创建采购单"
            >
                <r-switch :formData="formData" field="purchase_status" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启"
                          unCheckedChildren="关闭"/>

            </a-form-item> -->
            <a-form-item
                    label="状态"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <r-switch :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2" checkedChildren="上架"
                          unCheckedChildren="下架"/>

            </a-form-item>

            <a-affix :offsetBottom="0">
                <div style="background: #fff; padding: 10px 0 20px 0 ; border-top: 1px solid #eee  ">
                    <a-button style="margin-right: 10px;" @click="$router.push({name:'GoodsList'})">返回</a-button>
                    <a-button type="primary" style="margin-right: 10px;" :loading="saveLoading" @click="submitForm">保存 &
                        下一步
                    </a-button>
                    <a-button v-if="formData.id" @click="nextStep">下一步</a-button>
                </div>
            </a-affix>
        </a-form>
        <div style="flex: 1; display: none">
            <div class="simulator">
                <div class="simulator-content"></div>
            </div>
        </div>

    </div>
</template>
<style>
    .simulator {
        background: url('~@/assets/images/bg-phone-wrap.png') no-repeat;
        width: 320px;
        height: 865px;
        position: fixed;
        z-index: 10;
        right: 30px;
        top: 100px;
        background-size: 100%;
    }
</style>
<script>
    import {getCateTreeList, editGoods, addGoods, getGoodsDetail, getBaseOptions} from '@/api/goods'
    import {getCateList} from '@/api/businessGoods'

    import {getExpressTplOptions} from '@/api/express'
    import PicUploader from '@/components/PicUploader/'
    import VideoUploader from '@/components/VideoUploader/'
    import PriceInput from '@/components/PriceInput/'
    import RSwitch from '@/components/RSwitch/'

    export default {
        name: 'GoodsFormStep1',
        components: {
            PicUploader, PriceInput, RSwitch, VideoUploader
        },
        data() {
            return {
                saveLoading: false,
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 16},
                },
                form: this.$form.createForm(this),
                cateOptions: [],
                businessCateOptions: [],
                expressTplOptions: [],
                baseOptions: [],
                extraTypes: [
                    {id: 1, key: "1", name: "海外直邮", title: "海外直邮", value: "1"}
                ],
                formData: {
                    title: '',
                    title_en: '',
                    desc: '',
                    desc_en: '',
                    cate_ids: [],
                    business_cate_ids: [],
                    id: 0,
                    base_id: undefined,
                    pic: [],
                    pics: [],
                    extra_data: [],
                    order_data:[],
                    extra_types: [],
                    sold_count: 0,
                    orig_price: '',
                    sold_show_count: 0,
                    views_count: 0,
                    views_show_count: 0,
                    user_buy_limit: 0,
                    credit_limit:0,
                    express_price: 0,
                    member_buy_status: 2,
                    purchase_status:2,
                    status: 1,
                    videos: []
                },
            }

        },
        mounted() {
            let that = this;
            console.log('that.$route.query.id');
            console.log(that.$route.query.id);
            that.formData.id = that.$route.query.id;
            that.fetch();
        },
        methods: {
            fetch() {
                let that = this;
                if (that.formData.id) {
                    getGoodsDetail({
                        id: that.formData.id
                    }).then(res => {
                        that.formData = res.data;
                        if (res.data.express_tpl_id == 0) {
                            delete that.formData.express_tpl_id
                        }

                        setTimeout(() => {
                            that.form.setFieldsValue({...res.data});
                        }, 1)
                        that.$emit('updateGoods', res.data)
                    }).catch(err => {
                        that.$message.error(err.data.msg);
                    })
                }
                getCateTreeList()
                    .then(res => {
                        that.cateOptions = res.data;
                        that.cateOptions.map(cate => {
                            cate.id = cate.id + '';
                        })
                    })

                getCateList().then(res => {
                    that.businessCateOptions = res.data
                    that.businessCateOptions.map(cate => {
                        cate.id = cate.id + '';
                    })
                })
                getExpressTplOptions()
                    .then(res => {
                        that.expressTplOptions = res.data;
                    })
                getBaseOptions()
                    .then(res => {
                        that.baseOptions = res.data;
                    })
            },
            addExtraField() {
                if (this.formData.extra_data.length && this.formData.extra_data[this.formData.extra_data.length - 1].name == '') {
                    return false;
                }
                this.formData.extra_data.push({'name': '', 'value': ''});
            },
            removeExtraField(k) {
                this.formData.extra_data.splice(k, 1);
            },
            addOrderField(){
                if (this.formData.order_data.length && this.formData.order_data[this.formData.order_data.length - 1].name == '') {
                    return false;
                }
                this.formData.order_data.push({'name': '', 'value': ''});
            },
            removeOrderField(k){
                this.formData.order_data.splice(k, 1);
            },
            submitForm(e) {
                let self = this
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                        self.saveLoading = true;
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData)
                        self.saveLoading = true;
                        if (self.formData.id) {
                            editGoods(Object.assign(self.formData, values)).then(res => {
                                self.$message.success('保存成功')
                                self.saveLoading = false;
                            }).catch(err => {
                                self.$message.error(err.data.msg);
                                self.saveLoading = false;
                            })
                        } else {
                            addGoods(Object.assign(self.formData, values)).then(res => {
                                self.formData.id = res.data.id
                                self.formData.rank = res.data.rank
                                self.$message.success('保存成功')
                                self.$emit('updateGoods', res.data)
                                self.saveLoading = false;
                            }).catch(err => {
                                self.$message.error(err.data.msg);
                                self.saveLoading = false;
                            })
                        }
                    } else {
                        console.log(err);
                    }
                })
            },
            nextStep(e) {
                this.$emit('nextStep')
            }
        }
    }
</script>

<style scoped>
    .order_expr{
        display: flex;
        align-items: flex-start;
    }
</style>